export function getShortenedZipCode(zipCode: string) {
  return zipCode.split('-')[0];
}
